export class AttendeeModel{

    constructor(firstName, lastName, company, email, address1, address2, city, country, province, postalCode, phone){
        this.firstName = firstName;
        this.lastName = lastName;
        this.company = company;
        this.email = email;
        this.address1 = address1;
        this.address2 = address2;
        this.city = city;
        this.country = country;
        this.province = province;
        this.postalCode = postalCode;
        this.phone = phone;
    }
    firstName: string;
    lastName: string;
    company: string;
    email: string;
    address1: string;
    address2: string;
    city: string;
    country: string;
    province: string;
    postalCode: string;
    phone: string;
}

export class CourseRegistrationModel{
    courseId: number;
    courseName: string;
    courseFee: number;
    quantity: number;
    attendees: AttendeeModel[];
}

export class RegistrationModel{
    courseRegistrationModels: CourseRegistrationModel[];
}



// WEBPACK FOOTER //
// ./src/app/Models/registration.model.ts